import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4199e80"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "blocking-text"
}

import ChatMessage from "@/components/chat/chatContainer/ChatMessage/ChatMessage.vue";
import { showReadAt } from "@/utils/message";
import { useGetChatContentProperties } from "./useGetChatContentProperties";
import { ChatBlockingStatusEnum, Message } from "@/store/chats/types";

interface ChatContentProps {
  messages: Message[];
  blockingStatus?: ChatBlockingStatusEnum;
  isDeleted?: boolean;
  userName?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatContent',
  props: {
    messages: { default: () => [] },
    blockingStatus: { default: undefined },
    isDeleted: { type: Boolean, default: undefined },
    userName: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const {
  el,
  scrollContainerRef,
  handleBlurInput,
  visibleMessages,
  isBlockingTextShown,
  deletingMessages,
  convertedDateString,
  blockingStrings,
  sentinelRef,
  bottomAnchorRef,
  isScrollDisabled,
  isReplyingOrEditing,
} = useGetChatContentProperties(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "el",
    ref: el,
    class: _normalizeClass(["chat-content", { isReplyingOrEditing: _unref(isReplyingOrEditing) }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleBlurInput) && _unref(handleBlurInput)(...args)))
  }, [
    _createElementVNode("div", {
      ref_key: "scrollContainerRef",
      ref: scrollContainerRef,
      class: _normalizeClass(["messages-wrapper", { isScrollDisabled: _unref(isScrollDisabled) }])
    }, [
      _createElementVNode("div", {
        ref_key: "sentinelRef",
        ref: sentinelRef
      }, null, 512),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleMessages), (message, index) => {
        return (_openBlock(), _createBlock(ChatMessage, {
          key: message.id,
          index: index,
          message: message,
          "visible-messages": _unref(visibleMessages)
        }, null, 8, ["index", "message", "visible-messages"]))
      }), 128)),
      (_unref(showReadAt)(_unref(visibleMessages), _unref(visibleMessages).length - 1))
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["read-at", _unref(deletingMessages) ? 'padding-right' : ''])
          }, _toDisplayString(_ctx.$t("chat.chatContainer.read")) + " " + _toDisplayString(_unref(convertedDateString)), 3))
        : _createCommentVNode("", true),
      (_unref(isBlockingTextShown))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockingStrings), (str, i) => {
              return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(str), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        ref_key: "bottomAnchorRef",
        ref: bottomAnchorRef
      }, null, 512)
    ], 2)
  ], 2))
}
}

})